import { render, staticRenderFns } from "./AddNotesToContractorsNew.vue?vue&type=template&id=5ac22fbe"
import script from "./AddNotesToContractorsNew.vue?vue&type=script&lang=ts"
export * from "./AddNotesToContractorsNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac22fbe')) {
      api.createRecord('5ac22fbe', component.options)
    } else {
      api.reload('5ac22fbe', component.options)
    }
    module.hot.accept("./AddNotesToContractorsNew.vue?vue&type=template&id=5ac22fbe", function () {
      api.rerender('5ac22fbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/AddNotesToContractorsNew.vue"
export default component.exports